export function generateCurrentDate(formatter){
    try {
        const striker = formatter ?? '_';
        const date = new Date();
        return date.getDate()+striker+date.getMonth()+striker+date.getFullYear();
    } catch (error) {
        console.log(error);
        return "";
    }
}